import axios from 'axios';
import { LanguageObject } from '@/i18n';
import AuthUtils from './AuthUtils';

interface UserAgreement {
  id: number;
  name: string;
  text: LanguageObject;
  checkboxlabel: LanguageObject;
  active: boolean;
}

const api = {
  list: async (params?: any) => {
    const resp = await axios.get<UserAgreement[]>('/userAgreements/list.php', {
      params: params,
    });
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<UserAgreement>('/userAgreements/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (useragreement: Partial<UserAgreement>) => {
    const resp = await axios.post<UserAgreement>(
      '/userAgreements/add.php',
      useragreement
    );
    return resp.data;
  },

  update: async (useragreement: Partial<UserAgreement>) => {
    const resp = await axios.post<UserAgreement>(
      '/userAgreements/update.php',
      useragreement
    );
    return resp.data;
  },

  remove: async (id: number) => {
    await axios.delete('/userAgreements/delete.php', {
      params: { id: id },
    });
  },

  accept: async () => {
    await axios.get<UserAgreement[]>('/userAgreements/accept.php');
    AuthUtils.set({ useragreements: [] });
  },
};

export default {
  api,
};

export { UserAgreement };
